<template>
	<div class="wrap home"><!-- home 클래스 추가 -->
  <div class="contents_wrap">
			<section>
				<div class="contents">

         <div class="home_header">
            <div class="home_header_inner">

              <p class="user">안녕하세요, <span>{{ $store.getters.userInfo.userName }}</span>님!<br>오늘의 캠페인은 <strong style="font-weight: 500;font-size: 36px;">총 {{todayCampCnt}}</strong>건입니다.</p>

              <div class="states">
                <div class="date">{{datetit}}  {{day}}요일</div>
                <ul>
                  <li>전체<span class="s1"> {{todayCampCnt}}</span></li>
                  <li>진행중<span class="s2">{{todayIngCount}}</span></li>
                  <li>대기중<span class="s3">{{todayWaitCount}}</span></li>
                  <li>완료<span class="s4">{{todayCompleteCount}}</span></li>
                  <li>중지/취소<span class="s5">{{todaySumStopCancelCount}}</span></li>
                  <!-- <li>취소<span class="s5">{{todayCancelCount}}</span></li> -->
                </ul>
              </div>

            </div>
          </div>


          
          <div class="home_contents">

            <div class="today_graph">
              <div class="tit_wrap">
                <h3>오늘의 통화현황</h3>
                <span class="refresh" style="cursor:pointer;" @click="onHomeInfoList"> {{date}} {{time}} 기준<i></i></span>
              </div>

              <!-- chart Wrap : vue cdn -->
              <div id="app">

                <div class="chartWrap">
                  <canvas id="myChart" width="400" height="400"></canvas>

                  <div class="txt">통화 연결률</div>
                  <div class="per">{{todayCallRatio}}<span>%</span></div>
                </div>

                <ul class="chart_data">
                  <li>
                    <span>오늘의 통화시도</span>
                    <strong id="callTryCnt">{{todayCallTryCnt}}<em>건</em></strong>
                  </li>
                  <li>
                    <span>오늘의 통화연결</span>
                    <strong id="callConnCnt">{{todayCallConnCnt}}<em>건</em></strong>
                  </li>
                </ul>

              </div>

              <!-- // chart Wrap : vue cdn -->
            </div>

            <div class="today_campaign" style="z-index:1;">
              <div class="tit_wrap">
                <h3>오늘의 캠페인</h3>
                <span class="campaign_mgt" style="cursor:pointer;" @click="onCampClick">캠페인 관리</span>
              </div>


              <div ref="useData" class="data_tbl_list"  v-if="campList.length > 1">
                <table class="table1">
                  <tbody>
                    <tr v-for="camp in campList" >
                      <td style="width:84px" @click="showScheduleDetail(camp)" v-if="camp.scheduleStatus ==='A'"><strong class="status waiting">임시저장</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)" v-if="camp.scheduleStatus ==='B'"><strong class="status waiting">대기</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)" v-if="camp.scheduleStatus ==='C'"><strong class="status ing">진행중</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='D'"><strong class="status done">완료</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='E'"><strong class="status cancel">중지</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='G'"><strong class="status cancel">중지S</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='F'"><strong class="status cancel">취소</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='H'"><strong class="status cancel">취소S</strong></td>                      
                      <td style="width:auto" @click="showScheduleDetail(camp)"  class="tit">{{camp.scheduleName}}<span class="date">{{camp.startDate.substring(0,4)}}-{{camp.startDate.substring(4,6)}}-{{camp.startDate.substring(6,8)}} ~ {{camp.endDate.substring(0,4)}}-{{camp.endDate.substring(4,6)}}-{{camp.endDate.substring(6,8)}}</span></td>
                      <td style="width:116px" @click="showScheduleDetail(camp)"  class="tar"><span class="txt">통화시도</span>{{camp.retryNumber}}</td>
                      <td style="width:103px" @click="showScheduleDetail(camp)"  class="tar"><span class="txt">통화연결</span>{{camp.calleeCount}}</td>
                      <td style="width:80px" class="tar">
                        <div class="menu_wrap">
                          <aicc-icon-drop-holder :items="dropHolderItems(camp)" v-model="dropHolderValue" @input="dropHolderInput">
                            <ur-button class="btn_more"/>
                          </aicc-icon-drop-holder>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div ref="oneData" class="data_tbl_list" v-if="campList.length === 1">
                <table class="table1">
                  <tbody>
                     <tr v-for="camp in campList">
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='A'"><strong class="status waiting">임시저장</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='B'"><strong class="status waiting">대기</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='C'"><strong class="status ing">진행중</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='D'"><strong class="status done">완료</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='E'"><strong class="status cancel">중지</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='G'"><strong class="status cancel">중지S</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='F'"><strong class="status cancel">취소</strong></td>
                      <td style="width:84px" @click="showScheduleDetail(camp)"  v-if="camp.scheduleStatus ==='H'"><strong class="status cancel">취소S</strong></td>  
                      <td style="width:auto" @click="showScheduleDetail(camp)"  class="tit">{{camp.scheduleName}}<span class="date">{{camp.startDate.substring(0,4)}}-{{camp.startDate.substring(4,6)}}-{{camp.startDate.substring(6,8)}} ~ {{camp.endDate.substring(0,4)}}-{{camp.endDate.substring(4,6)}}-{{camp.endDate.substring(6,8)}}</span></td>
                      <td style="width:116px" @click="showScheduleDetail(camp)"  class="tar"><span class="txt">통화시도</span>{{camp.retryNumber}}</td>
                      <td style="width:103px" @click="showScheduleDetail(camp)"  class="tar"><span class="txt">통화연결</span>{{camp.calleeCount}}</td>
                      <td style="width:80px"  class="tar">
                        <div class="menu_wrap">
                         <aicc-icon-drop-holder :items="dropHolderItems(camp)" v-model="dropHolderValue" @input="dropHolderInput">
                            <ur-button class="btn_more"/>
                          </aicc-icon-drop-holder> 
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="5" class="no_campaign type2" style="cursor:default;">
                        <div class="">
                          <span>새로운 캠페인을 만들어보세요.</span>
                          <button type="button" class="btn btn_color primary btn_l" @click="registerOutCallSchedule">새 캠페인 만들기 </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>


              <div ref="noData" class="data_tbl_list" v-if="campList.length === 0">
                <table class="table1">
                  <tbody>
                    <tr>
                      <td colspan="5" class="no_campaign" style="cursor:default;">
                        <div class="">
                          <p>오늘 캠페인 일정이 없습니다.</p>
                          <span>새로운 캠페인을 만들어보세요.</span>
                          <button type="button" class="btn btn_color primary btn_l" @click="registerOutCallSchedule">새 캠페인 만들기 </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>

          </div>
<!-- 
          <div class="home_footer">
            <p class="copy">Copyright 2021 SAMSUNG SDS. All rights reserved.</p>
            <ul>
              <li><a href="#">서비스 이용약관</a></li>
              <li><a href="#">개인정보 처리방침</a></li>
            </ul>
            <p class="footer_logo">SAMSUNG SDS</p>
          </div> -->
          <schedule-detail-popup ref="scheduleDetailPopup" :pageId="contextPageId" 
              :pageInitialData="pageInitialData" @closeDetailPopup="closeDetailPopup"/>
        </div>
      </section>
  </div>

  <div>
    <ur-snackbar ref="snackbar" :duration="3000"></ur-snackbar>
  </div>

  </div>
</template>

<style> 
.cont2 {flex:0 0 120px;text-align:right;}
.v-application--wrap {min-height:auto;}
</style>
<script>
import { urDataSet } from 'uidev-component/index.js';
import BasePage from '~cm/components/BasePage';
import Notice from '../N/components/PGE_AIN_00001_P01';
import scheduleDetailPopup from '../../components/CMP_AIC_00005/CMP_AIC_00005.vue';
import home from '~assets/css/aicc/home.css';
import Chart from 'chart.js';
import urCustomDropHolder from '../../components/CMP_AIC_00002.vue';

export default {
  name: 'PGE_AIC_00012', // eslint-disable-line vue/name-property-casing
  components: {
    notice:Notice,
    scheduleDetailPopup,
  },
  extends: BasePage,
  data() {
    return {
      datetit: this.getDateTit(),
      date: this.getDate(),
      day: this.getDay(),
      time: this.getTime(),
      todayCampCnt: utils.numberFormat(this.todayCampCnt),
      todayCallTryCnt: utils.numberFormat(this.todayCallTryCnt),
      todayCallConnCnt: utils.numberFormat(this.todayCallConnCnt),
      todayCallRatio: this.todayCallRatio,
      todayIngCount: utils.numberFormat(this.todayIngCount),
      todayWaitCount: utils.numberFormat(this.todayWaitCount),
      todayCancelCount: utils.numberFormat(this.todayCancelCount),
      todayStopCount: utils.numberFormat(this.todayStopCount),
      todayCompleteCount: utils.numberFormat(this.todayCompleteCount),
      todaySumStopCancelCount: utils.numberFormat(Number(this.todayCancelCount) + Number(this.todayStopCount)),
      campList: [],
      homeStatusAsk: {
        tenantId: '',
      },
      dropHolderValue: {},
      pageInitialData: {},
      interval: null,
    };
  },
  computed: {
    modal() {
      return this.$refs.modal;
    },
     dropHolderItems() {
                  return (row) => {
                    // 1. 캠페인 상태에 따라 노출되는 항목 상이 
                    // - 대기중(B) : 상세 조회
                    // - 진행중(C), 완료(D), 정지(E), 취소(F) : 상세 조회, 실시간 모니터링
                    let dropHolderItems = [];
                    let scheduleInfo = {};
                                        
                    scheduleInfo.scheduleId = row.scheduleId;
                    scheduleInfo.scheduleStatus = row.scheduleStatus; 
                    scheduleInfo.scheduleName = row.scheduleName;
                    dropHolderItems.push({value:{action: 'detail', row}, text:'상세 조회', iconType:'list',});
                                       
                    if (row.scheduleStatus === 'C') {
                      dropHolderItems.push({isSeparator:true,}); 
                      dropHolderItems.push({value:{action: 'realtime', scheduleInfo}, text:'실시간 모니터링', iconType:'realtime',}); 
                    }
                    return dropHolderItems;
                  };
                  
                }
  },
  watch: {},
  created() {
        
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });

   this.interval = setInterval(this.onHomeInfoList, 10000);
  },
  beforeUpdate() {
    this.$store.commit('hideLNB');
    this.$store.commit('showFooter');
    this.$store.commit('hideLoading');
  },
  updated() {},
  beforeDestroy() {
      if(this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
  },
  destroyed() {},
  methods: {
    showSnackbar(message) {
      this.$refs.snackbar.show({text: message});
    },
    onLoad() {
      
      this.onHomeInfoList();
      
    },
    onHomeInfoList() {
      this.homeStatusAsk.tenantId = this.tenantId;
      this.homeStatusAsk.chartYn = 'N';
      this.homeStatusAsk.nowDate = new Date();
      http.request(this.contextPageId, 'DTS_AIC_00013', {
         data: this.homeStatusAsk,
      }).then((response) => {
        var data = response.data;  
        this.datetit = this.getDateTit(),
        this.date = this.getDate(),
        this.day = this.getDay(),
        this.time = this.getTime(),
        // this.todayCampCnt = utils.numberFormat(data.campCount);
        this.todayCampCnt = utils.numberFormat(Number(data.ingCount)+ Number(data.waitCount)+ Number(data.cancelCount)+ Number(data.stopCount)+ Number(data.completeCount));
        this.todayCallTryCnt = utils.numberFormat(data.retryCount);
        this.todayCallConnCnt = utils.numberFormat(data.callCount);
        this.campList = data.campList;
        this.todayCallRatio = data.callRatio;
        this.todayIngCount = utils.numberFormat(data.ingCount);
        this.todayWaitCount = utils.numberFormat(data.waitCount);
        this.todayCancelCount = utils.numberFormat(data.cancelCount);
        this.todayStopCount = utils.numberFormat(data.stopCount);
        this.todayCompleteCount = utils.numberFormat(data.completeCount);
        this.todaySumStopCancelCount = utils.numberFormat(Number(data.stopCount) + Number(data.cancelCount));

        console.log(this.todaySumStopCancelCount);
        this.createChart('myChart', this.todayCallRatio);
      });
      
      
    },
    getDateTit() {
      var today= new Date();
      var datetit = today.getFullYear()+'년 '+(today.getMonth()+1)+'월 '+today.getDate()+'일';
      return datetit;
    },
    getDate() {
      var today= new Date();

      var date = today.getFullYear()+'-'+(('0'+(today.getMonth()+1)).toString()).slice(-2) +'-'+(("00"+today.getDate().toString()).slice(-2));
      return date;
    },
    getDay() {
      var today= new Date();
      var week = ['일','월','화','수','목','금','토'];
      var day = week[today.getDay()];
      return day;
    },
    getTime() {
      var today= new Date();
      var hh = today.getHours().toString();
      var mm = today.getMinutes().toString();
      var ss = today.getSeconds().toString();
      
      var time = (hh[1]?hh:"0"+hh[0])+":"+(mm[1]?mm:"0"+mm[0])+":"+(ss[1]?ss:"0"+ss[0]); 
      return time;
    },
    createChart(chartId, percent) {
      var config = {
                  type: 'doughnut',
                  data: {
                    datasets: [{
                        data: [percent, 100-percent],
                        backgroundColor: [
                          'rgb(81, 106, 244)',
                          'rgb(225, 226, 232)'
                        ],
                        hoverOffset: 0,
                        borderWidth: 0
                      }],
                  },
                  options: {
                    elements: {
                      arc: {
                        roundedCornersFor: 0
                      }
                    },
                    cutoutPercentage: 84,
                  }
                };
     var ctx = document.getElementById("myChart").getContext("2d");
     var myChart = new Chart(ctx, config);
    },  
    openModal()  {
      //공지사항 임시 사용 
      this.$refs['noticeModal'].open();
    },
    onCampClick() {
      //this.$store.getters.lnbShowed;
      /*
      this.$router.push({
            path: '/Redirect',
            query: { pageId: 'PGE_AIC_00004' },
          });
          */
         //window.location.href="/home/saas1/#/PGE_AIC_00004";
         this.getComponent('aicc-frame').syncMenuStateByPageId('PGE_AIC_00004');
         utils.goPage('PGE_AIC_00004', null);
    },
  //   onChartClick() {
  //     console.log("onChartClick---");

  //       this.homeStatusAsk.chartYn = 'Y';

  //       this.date = this.getDate(),
  //       this.time = this.getTime(),
  //       this.onHomeInfoList();

  //     // http.request(this.contextPageId, 'DTS_AIC_00013', {
  //     //    data: this.homeStatusAsk,
  //     // }).then((response) => {
  //     //   var data = response.data; 
  //     //   this.date = this.getDate(),
  //     //   this.time = this.getTime(),
  //     //   this.todayCallTryCnt = data.retryCount;
  //     //   this.todayCallConnCnt = data.callCount;
  //     //   $('#callTryCnt').val(this.todayCallTryCnt);
  //     //   $('#callConnCnt').val(this.todayCallConnCnt);
  //     //   this.createChart('myChart', this.todayCallRatio);
        
  //     // });          
  // },
   moreMenuSelected(value) {
      switch(value.action) {
        case 'detail': 
          this.showScheduleDetail(value.row); 
          break;
        case 'realtime'  : 
          this.$store.getters.lnbShowed;

         this.getComponent('aicc-frame').syncMenuStateByPageId('PGE_AIC_00014');
         utils.goPage('PGE_AIC_00014', {
          selectedCampaignId: value.scheduleInfo.scheduleId,
      });

        // this.$router.push({
        //   path: '/Redirect',
        //   query: { pageId: 'PGE_AIC_00014', selectedCampaignId: value.scheduleInfo.scheduleId },
        // });
          break;
      }
    },
    dropHolderInput(value) {
      let parent = this.getComponent('PGE_AIC_00004');
      this.moreMenuSelected(value);
    },
    getComponent(name) {
      let component = null;
      let thisComponent = this;
      while(thisComponent && !component) {
         if(thisComponent.$options.name === name) {
           component = thisComponent;
           break;
         }
      thisComponent = thisComponent.$parent;
                  }
      return component;
     },
  showScheduleDetail(row) {
    /*
    캠페인 상세팝업 변경 -> 홈화면 레이어팝업 호출방식도 캠페인 관리와 동일하게 변경함.
    */
      this.pageInitialData.tabIdx = 1;
      this.pageInitialData.scheduleId = row.scheduleId;
      this.pageInitialData.parentPageId = this.contextPageId;
      this.$refs['scheduleDetailPopup'].open();
    // this.homeStatusAsk.scheduleId = row.scheduleId;
    // this.homeStatusAsk.tenantId = row.tenantId;
    //   http.request(this.contextPageId, 'DTS_AIC_00022', {
    //      data: this.homeStatusAsk,
    //   }).then((response) => {
    //     var data = response.data; 
       
    //     let selectedScheduleId = data.scheduleId;
    //     let selectedCallTotalCnt = data.callTotalCnt;
    //     let selectedCallSuccessCnt = data.callSuccessCnt;
    //     let selectedCallReserveCnt = data.callReserveCnt;
    //     let selectedCallSuccessRatio = data.callSuccessRatio;
    //     let selectedCalleeCnt = data.calleeCnt;
    //     let selectedCallCntByCallee = data.callCntByCallee;
    //     let selectedCallSuccessCntByCallee = data.callSuccessCntByCallee;
    //     let selectedCallSuccessRatioByCallee = data.callSuccessRatioByCallee;
    //     let selectedScenarioStartCntByCallee = data.scenarioStartCntByCallee;
    //     let selectedScenarioEndCntByCallee = data.scenarioEndCntByCallee;
    //     let selectedScenarioEndRatioByCallee = data.scenarioEndRatioByCallee;
    //     console.log(selectedCalleeCnt+'!!!!!!!!!!');
    //     let initialTabIdx = 2;
         // /**
        //  * 페이지 팝업
        //  *
        //  * @param {String} pageId 페이지아이디
        //  * @param {Function} closeCallback 닫기 버튼에 대한 콜백함수.
        //  * @param {Object} options
        //  * @param {String} options.size sm, md, lg, xlg 이 네 값 중에 하나만 유효함.
        //  * @param {String} options.pageInitialData
        //  */
        // utils.openLayerPopup('/PGE_AIC_00004_P01',
        //   this.onClosePagePopup,
        //   {
        //     pageInitialData: {
        //       tabIdx: initialTabIdx,
        //       scheduleId: selectedScheduleId,
        //       callTotalCnt: selectedCallTotalCnt,
        //       callSuccessCnt: selectedCallSuccessCnt,
        //       callReserveCnt: selectedCallReserveCnt,
        //       callSuccessRatio: selectedCallSuccessRatio,
        //       calleeCnt: selectedCalleeCnt,
        //       callCntByCallee: selectedCallCntByCallee,
        //       callSuccessCntByCallee: selectedCallSuccessCntByCallee,
        //       callSuccessRatioByCallee: selectedCallSuccessRatioByCallee,
        //       scenarioStartCntByCallee: selectedScenarioStartCntByCallee,
        //       scenarioEndCntByCallee: selectedScenarioEndCntByCallee,
        //       scenarioEndRatioByCallee: selectedScenarioEndRatioByCallee,
        //     },
        //     size: 'xlg',
        //   }
        // );
        
      // }).catch(err=>{
      //   console.log(err)
      // });
       
      },
      
      closeDetailPopup() {
        this.showMsgAfterChildClosed();
      },

      registerOutCallSchedule() {
        // 등록버튼 누른 경우 작성화면을 윈도우 팝업으로 띄운다.
        // let modeValue = 'I';
        // let url = `/popup.html#/PGE_AIC_00003?mode=${modeValue}`;
        // this.registerPopupWindow = window.open(window.location.pathname + url, '', 'width=1500,height=900,location=no,menubar=no,status=no,toolbar=no,resizable=yes');
        // this.registerPopupWindow.addEventListener('beforeunload', this.onClosePagePopup);

        let modeValue = 'I';
        this.registerPopupWindow = aiccUtils.newOutCallSchedulePopup(modeValue, "", (event) => { this.showMsgAfterChildClosed()});
      },

      showMsgAfterChildClosed() {
        // console.log('showMsgAfterChildClosed() was called.');
        // console.log('modeValueFromChild', window.modeValueFromChild)
        // console.log('outCallSchduleInfoFromChild', window.outCallSchduleInfoFromChild)
        
        if (!window.outCallSchduleInfoFromChild || !window.outCallSchduleInfoFromChild.scheduleId) {
          return;
        }

        // 캠페인 상태 변경시에는 modeValueFromChild 값이 'statusChanged'로 넘어오지만 
        // CMP_AIC_0005(상세조회 모달)에서 변경되었다는 것을 이미 알려줬기 때문에 여기서는 메시지 보여주지 않고 리스트만 갱신한다.

        let scheduleName = '';
        if (!utils.isEmpty(window.outCallSchduleInfoFromChild.scheduleName)) {
          scheduleName = "'" + window.outCallSchduleInfoFromChild.scheduleName + "'";
        }

        if (window.modeValueFromChild === 'I' || window.modeValueFromChild === 'C') {
          this.showSnackbar(utils.strFormat("{0} 캠페인이 등록되었습니다.", scheduleName));
        }
        if (window.modeValueFromChild === 'U' || window.modeValueFromChild === 'UB') {
          this.showSnackbar(utils.strFormat("{0} 캠페인이 수정되었습니다.", scheduleName));
        }
        if (window.modeValueFromChild === 'D') {
          this.showSnackbar(utils.strFormat("{0} 캠페인이 삭제되었습니다.", scheduleName));
        }

        // 등록/수정화면에서 registerCancelModal 이 뜬 상태에서 '확인'하고 넘어오면
        // modeValueFromChild 값에 'Cancel'이 붙어온다.
        if (window.modeValueFromChild.substr(1,6) === 'Cancel') {
          this.showSnackbar(utils.strFormat("작업이 취소되었습니다."));
        }

        window.modeValueFromChild = '';
        window.outCallSchduleInfoFromChild = '';

      },
  },
  
};
</script>
